import { CoreBancarioCasosUso } from './CoreBancarioCasosUso';
export default CoreBancarioCasosUso;
